module.exports = __webpack_public_path__ + "static/media/medpad-slide4.fd1015bd.png";